import React, {useContext} from "react";
import {
    Button,
    Drawer,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {HugeiconsIcon} from "@hugeicons/react";
import {ConstructionIcon, Key01Icon, Logout01Icon, Menu01Icon} from "@hugeicons/core-free-icons";
import {NavLink} from "react-router-dom";
import {WebSettingsContext} from "../../../context/WebSettingsContext";
import {MODEL_LINKS} from "./modelLinks";

export const HeaderDrawer = ({open, handleClose, isAuth, isAdmin, isManager, currentUser, onLogout, openModal}) => {
    const modelLinks = isAdmin ? MODEL_LINKS : MODEL_LINKS.filter(link => !link.adminOnly);

    const {settings, onUnderMaintenance} = useContext(WebSettingsContext);

    const logoutHandle = async () => {
        try {
            await onLogout();
            handleClose();
        } catch (err) {
            console.error(err);
        }
    }

    const handleNav = () => handleClose();

    return (
        <Drawer
            anchor={"right"}
            open={open}
            onClose={handleClose}
            sx={{
                height: "100vh",
                width: '100%',
                flex: 1,
                display: {xs: "inherit", md: "none"}
            }}
            PaperProps={{
                sx: {
                    maxWidth: "360px",
                    width: "100% !important",
                },
            }}
        >
            <Stack direction={"column"} gap={1} sx={{
                height: "100vh",
                maxWidth: "360px",
                width: "100% !important",
                bgcolor: "#FFF"
            }}>
                <Box sx={{ p: 2, bgcolor: "#FFF" }}>
                    <IconButton onClick={handleClose}>
                        <HugeiconsIcon icon={Menu01Icon} />
                    </IconButton>
                </Box>

                {isAuth && currentUser && (
                    <Box sx={{ px: 2, pb: 1 }}>
                        <Typography variant={"subtitle2"} fontWeight={"bold"}>
                            {currentUser?.name} {currentUser?.lastname}
                        </Typography>
                    </Box>
                )}

                <Box sx={{ flex: 1, maxHeight: "100%", overflowY: 'auto' }}>
                    <List>
                        {isAdmin && (
                            <>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/projects"} end>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Projects</Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/organizations"}>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Organizations</Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/users"}>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Users</Typography>
                                    </ListItemText>
                                </ListItemButton>
                            </>
                        )}

                        {(isAdmin || isManager) && (
                            <>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/backend-configuration"}>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Backend Configuration</Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <ListSubheader sx={{lineHeight: "32px", mt: 1}}>Models</ListSubheader>
                                {modelLinks.map(link => (
                                    <ListItemButton key={link.to} onClick={handleNav} component={NavLink} to={link.to} sx={{pl: 3}}>
                                        <ListItemIcon>
                                            <HugeiconsIcon icon={link.icon} size={20}/>
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Typography variant={"subtitle2"} fontWeight={"bold"}>{link.label}</Typography>
                                        </ListItemText>
                                    </ListItemButton>
                                ))}
                            </>
                        )}

                        {isAuth && (
                            <ListItemButton onClick={handleNav} component={NavLink} to={"/api-keys"}>
                                <ListItemIcon>
                                    <HugeiconsIcon icon={Key01Icon} />
                                </ListItemIcon>
                                <ListItemText primary={"API Keys"} />
                            </ListItemButton>
                        )}

                        {isAdmin && (
                            <ListItemButton onClick={onUnderMaintenance}>
                                <ListItemIcon>
                                    <HugeiconsIcon icon={ConstructionIcon} color={settings?.underMaintenance ? "#d32f2f" : undefined} />
                                </ListItemIcon>
                                <ListItemText primary={"Under Maintenance"} />
                            </ListItemButton>
                        )}

                        {isAuth ? (
                            <ListItemButton onClick={logoutHandle}>
                                <ListItemIcon>
                                    <HugeiconsIcon icon={Logout01Icon} />
                                </ListItemIcon>
                                <ListItemText primary={"Logout"} />
                            </ListItemButton>
                        ) : (
                            <Box sx={{ px: 2, pt: 1 }}>
                                <Button
                                    fullWidth
                                    onClick={() => {
                                        openModal();
                                        handleClose();
                                    }}
                                    sx={{
                                        borderRadius: 0,
                                        textTransform: "capitalize",
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        color: '#4a4a4a',
                                        borderColor: "#4a4a4a",
                                        border: 1,
                                        "&:hover": {
                                            color: "#FFF",
                                            bgcolor: "#4a4a4a"
                                        }
                                    }}
                                >
                                    Sign in
                                </Button>
                            </Box>
                        )}
                    </List>
                </Box>
            </Stack>
        </Drawer>
    )
}
